import {Component, OnInit, Input, Output, EventEmitter, OnDestroy} from '@angular/core';
declare var $:any;
import * as moment from 'moment';
import {Task} from "../../../entities/Task";
import {ResourceTaskTime} from "../../../entities/ResourceTaskTime";
import {Resource} from "../../../entities/Resource";
import {environment} from "../../../../environments/environment";
import {CalendarFilter} from "../../../entities/Calendar";
import {Job} from "../../../entities/Job";
import {TaskPageModel, TaskTypes, ViewNames} from "../../../entities/PageModel";
import {JobCalendar} from "../../../entities/JobCalendar";
import {IMyDpOptions, IMyDateModel} from "mydatepicker";

@Component({
  selector: 'app-responsible-calendar-view',
  templateUrl: './responsible-calendar-view.component.html',
  styleUrls: ['./responsible-calendar-view.component.css']
})
export class ResponsibleCalendarViewComponent implements OnInit, OnDestroy {


  @Input()
  calendar : JobCalendar = null;

  @Input()
  unPlannedTasks : TaskPageModel;
  @Input()
  plannedTasks : TaskPageModel;

  @Input()
  employeeEvents: ResourceTaskTime[];
  @Input()
  calendarDate : string;
  @Input()
  firstRun : Boolean;

  @Input()
  ChosenJob : Job;

  //@Input()
  //Jobs : Job[];

  @Input()
  JobTasks : Task[];

  @Input()
  ChosenTaskRef : string;



  @Output()
  updateJobTimeEmitter = new EventEmitter();

  @Output()
  changeChosenResponsibleEmitter = new EventEmitter();


  @Output()
  changeGlobalJobEmitter = new EventEmitter();

  calendarFilter = CalendarFilter.All;

  TaskTypes = TaskTypes;

  chosenTask : Task;

  listToShow: string = '1a';

  isDragging: boolean;

  doWork: boolean;

  viewNames = ViewNames;

  viewName: number;

  @Input()
  calendarTask : Task;

  @Input()
  maxResourceNameLength : number;

  @Input()
  responsibles: Resource[];
  @Input()
  chosenResponsible: Resource;

  eventHours : number;

  duration = 90;

  StartDate : any = new Date();

  EndDate : any = new Date();

  dummyStart;
  dummyEnd;

  dynamicSlotWidth : number = 10;

  currentView = 'dateRangeTimeLine';

  dateChanged: boolean = true;

  stateChange: boolean = false;


  public startDatePickerOptions: IMyDpOptions;

  public endDatePickerOptions: IMyDpOptions;

  constructor() {
  }

  ngOnInit() {
    this.chosenTask = new Task();
    this.isDragging = false;

    this.StartDate.setDate(new Date().getDate() - 3);
    this.EndDate.setMonth(new Date().getMonth() + 3);
    this.setOptionsData();

    this.setDuration()
  }

  ngOnDestroy(): void {
    $('.tooltipevent').remove();
  }

  redirectToScheduler(ChosenJob : string)
  {
    this.changeGlobalJobEmitter.emit(ChosenJob);
  }

  setOptionsData()
  {
    this.setDuration();
    this.dummyStart = { date: { year: this.StartDate.getFullYear(), month: this.StartDate.getMonth() + 1, day: this.StartDate.getDate() } };
    this.dummyEnd = { date: { year: this.EndDate.getFullYear(), month: this.EndDate.getMonth() + 1, day: this.EndDate.getDate() } };

    this.startDatePickerOptions = {
      // other options...
      dateFormat: 'dd/mm/yyyy',
      showWeekNumbers: true,
      showClearDateBtn: false,
      disableDateRanges: [{begin: this.dummyEnd.date, end: {year: 2055, month: 11, day: 20}}],
    };
    this.endDatePickerOptions = {
      // other options...
      dateFormat: 'dd/mm/yyyy',
      showWeekNumbers: true,
      showClearDateBtn: false,
      disableDateRanges: [{begin: {year: 1980, month: 11, day: 20}, end: this.dummyStart.date}],
    };
  }

  // Pagination


  setDuration()
  {

    let diff = Math.abs(this.getTimeOfDate(this.StartDate) - this.getTimeOfDate(this.EndDate));
    this.duration = Math.ceil(diff / (1000 * 3600 * 24)) + 1;

  }

  getTimeOfDate(date : Date) : number{
    let s = moment(date).format(environment.START_DATETIME_FORMAT);
    let d = new Date(s);
    return d.getTime();
  }

  setStartDate(event: IMyDateModel)
  {
    this.StartDate = event.jsdate;
    this.setOptionsData();

    this.rerenderCalendar(this.calendar);
  }

  setEndDate(event: IMyDateModel)
  {
    this.EndDate = event.jsdate;
    this.setOptionsData();

    this.rerenderCalendar(this.calendar);

  }

  changeChosenResponsible(ref : string)
  {
    this.changeChosenResponsibleEmitter.emit(ref);
  }

  updateJobTime(job : Job)
  {
      this.updateJobTimeEmitter.emit(job)
  }

  rerenderCalendar(calendar : JobCalendar)
  {
    let self = this;
    let jqueryCalendar = $('#calendar');

    setTimeout(function () {
      let d = new Date(0);
      d.setMilliseconds(jqueryCalendar.fullCalendar('getDate'));

      jqueryCalendar.fullCalendar('destroy');
      jqueryCalendar.fullCalendar('render');
    }, 200);
  }

  getJobTooltip(event : ResourceTaskTime)
  {
    let style = 'font-family: Helvetica; overflow: hidden;display:block; height: auto; border: 1px solid #cccccc; background-color: whitesmoke; border-radius: 3px; padding-top: 5px; padding-bottom: 5px;';


    var tooltip = '<div class="tooltipevent panel panel-default" align="center" ' +
      'style="width:260px;height:auto;position:absolute;' +
      'z-index:10001;border-radius: 6px;box-shadow: 1px 1px 5px"' +
      '><div class="panel-heading"><strong>' + event.Title + '</strong></div><div class="panel-body">' +
      '<p style="'+style+'+">' +
      moment(new Date(event.start)).format(environment.START_DATETIME_FORMAT_DANISH) + ' - ' + (event.end != null ? moment(new Date(event.end).setDate(new Date(event.end).getDate() - 1)).format(environment.START_DATETIME_FORMAT_DANISH) : moment(new Date(event.start)).format(environment.START_DATETIME_FORMAT_DANISH)) + '</p>' +
      '<p style="'+style+'+"><strong>Kunde:</strong> ' + event.Customer +'</pre>' +
      '<p style="'+style+'+"><strong>Beskrivelse:</strong> ' + event.Description + ' </p>' +
      '</div></div>';

    return tooltip;
  }

  openModal(task : Task)
  {
    Object.assign(this.chosenTask, task);
    $('#myModal').modal('show');

  }


  InitJS()
  {
    let self = this;
    $('#calendar').fullCalendar({
      schedulerLicenseKey: environment.SCHEDULER_TOKEN,
      locale: "da",
      timeZone: 'utc',
      defaultView: self.currentView,
      aspectRatio: 1.6,
      editable: true,
      droppable: true, // this allows things to be dropped onto the calendar !!!
      dragRevertDuration: 0,
      lazyFetching: true,
      minTime: "07:00:00",
      maxTime: "18:00:00",
      resourceAreaWidth:  self.maxResourceNameLength != 1 ? (self.maxResourceNameLength * 8.3).toString() + 'px' : "80px",
      defaultDate: self.StartDate,
      contentHeight: 'auto',
      subTitle: 'Ansatte',
      weekNumbers: true,
      // ResourceGroup Settings
      resourcesInitiallyExpanded: true,
      resourceGroupField: 'groupId',

      views: {
        allDayWeekTimeline: {
          type: 'timelineMonth',
          slotWidth: 44,
          dateAlignment: 'month',
        },
        yearTimeline: {
          slotWidth: 4.2,
          buttonText: "År",
          slotLabelFormat: [
            'MMMM', // top level of text
            '|'
          ],
          type: 'timelineYear',
        },
        dateRangeTimeLine: {
          slotWidth: self.dynamicSlotWidth,

          duration: {days: self.duration},
          type: 'timelineMonth',
          buttonText: 'Datointerval',
          slotLabelInterval: {days: 1},
          allDay: true,
          weekNumberTitle: ""
        }
      },
      resourceLabelText: 'Sager',
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'timelineWeek,allDayWeekTimeline,yearTimeline,dateRangeTimeLine'
      },

      businessHours: {
        // days of week. an array of zero-based day of week integers (0=Sunday)
        dow: [ 1, 2, 3, 4, 5 ], // Monday - Thursday

        start: '07:00', // a start time (10am in this example)
        end: '17:00', // an end time (6pm in this example)
      },
      resources: this.calendar.Resources,
      events: this.calendar.PlacedEvents,
      navLinks: true,
      // other options go here...

      viewRender: function(view, element)
      {
        // Automatically sets the minimum height of the view content to the current height, so the view doesnt jump when data is refreshed and rendered.


        if(view.type == "dateRangeTimeLine" && self.currentView != view.Type && self.stateChange)
        {


          self.stateChange = false;
          self.currentView = "dateRangeTimeLine";
          //self.StartDate = new Date(self.ChosenTask.start);

          self.rerenderCalendar(self.calendar);

        }
        if(view.type != "dateRangeTimeLine")
        {
          self.stateChange = true;
        }

        if(view.type == "month")
        {
          // Start and end date is both wrong compared to the choosen month. The chosen month is in between start and end, for some reason....
          let difference = view.end - view.start;
          let newStart = (view.start + (difference / 2));
          console.log(moment(newStart).format(environment.FULL_DATETIME_FORMAT_DANISH));

          $('#calendar').fullCalendar('changeView', 'allDayWeekTimeline');
          $('#calendar').fullCalendar('gotoDate', newStart);
        }
        else if(view.type == "basicDay")
        {
          // There is no timeline day in our version.. Therefor just reload current view, instead of basicDay default view.

          if(self.currentView == "dateRangeTimeLine")
          {
            // Fix bug where DatoInterval calendar changes date when day clicked.
            $('#calendar').fullCalendar('gotoDate', self.StartDate);
          }
          $('#calendar').fullCalendar('changeView', self.currentView);
        }


        if($('#calendar').fullCalendar('getView').type != undefined) {
          self.currentView = $('#calendar').fullCalendar('getView').type;
        }



        if(view.name == self.viewNames[self.viewNames.allDayWeekTimeline])
        {
          self.viewName = self.viewNames.allDayWeekTimeline;
        }
        else if(view.name == self.viewNames[self.viewNames.timelineWeek]){
          self.viewName = self.viewNames.timelineWeek;

        }

      },

      eventRender: function(event, element) {
        element.bind('dblclick', function(jsEvent ) {
          $('.tooltipevent').remove();
        self.redirectToScheduler(event.TaskRef);

      });
      },


      // This function is called when a event is dropped inside the calendar
      eventDrop: function(event, delta, revertFunc)
      {
        if(!event.HasBeenPlannedOn)
        {
        event.eventStartEditable = false;

          self.updateJobTime({No: event.id, start: event.start, end: event.end});
          event.OrigResourceRef = event.resourceId;
          self.setDragging(false);
        }
        else{
          alert("Der er blevet uddelegeret opgaver ud fra denne sag. \nFjern opgaverne først, og prøv igen. ")
          revertFunc();
        }
      },

      // This funtion is called when a event is resized
      eventResize: function(event, delta, revertFunc) {
        self.updateJobTime({No:event.id, start: event.start, end:event.end});
      },

      eventDragStart: function( event, jsEvent, ui, view ) {
        self.setDragging(true);
      },

      eventMouseover: function(calEvent, jsEvent) {
        if(self.isDragging == false) {
          let tooltip = self.getJobTooltip(calEvent);

          $("body").append(tooltip);
          $(this).mouseover(function(e) {
            $(this).css('z-index', 10000);
            $('.tooltipevent').fadeIn('500');
            $('.tooltipevent').fadeTo('10', 1.9);
          }).mousemove(function(e) {
            $('.tooltipevent').css('top',e.pageY + -parseInt($('.tooltipevent').css('height'), 10) + -15);
            $('.tooltipevent').css('left', e.pageX + -120);
          });
        }},

      eventMouseout: function(calEvent, jsEvent) {
        $(this).css('z-index', 8);
        $('.tooltipevent').remove();
      },

      resourceRender: function(resourceObj, labelTds, bodyTds) {
        let tooltip = self.getJobTooltip(resourceObj);

        labelTds.bind('dblclick', function() {
          self.redirectToScheduler(resourceObj.No);
        });
        labelTds.mouseenter(function(e) {
            $("body").append(tooltip);
          $(this).mouseover(function(e) {
            $(this).css('z-index', 10000);
            $('.tooltipevent').fadeIn('500');
            $('.tooltipevent').fadeTo('10', 1.9);
          }).mousemove(function(e) {
            $('.tooltipevent').css('top', e.pageY + -parseInt($('.tooltipevent').css('height'), 10) + -15);
            $('.tooltipevent').css('left', e.pageX + -100);
          });

        });
        labelTds.mouseleave(function(e) {
          $(this).css('z-index', 8);
          $('.tooltipevent').remove();
        });



      },

      resourceRenderCallback: function (resourceObj, labelTds, bodyTds){
        var title = 'Name: ' + resourceObj.title;

      },

    });

    if(this.firstRun &&  this.calendarDate != null)
    {
      $('#calendar').fullCalendar('gotoDate', this.calendarDate);
      this.firstRun = false;
    }



    // This function is called on every external event in the list.
    $('#external-events .fc-event').each(function() {

      // create an Event Object (http://arshaw.com/fullcalendar/docs/event_data/Event_Object/)
      // it doesn't need to have a start or end

      var eventObject = {
        title: $.trim($(this).text()), // use the element's text as the event title
        TaskRef: $(this).children('.taskRef').val(),
        stick: false
      };

      // store the Event Object in the DOM element so we can get to it later
      $(this).data('eventObject', eventObject);

      // make the event draggable using jQuery UI
      $(this).draggable({
        zIndex: 999,
        revert: true,      // will cause the event to go back to its
        revertDuration: 0  //  original position after the drag
      });
    });


  };

  setDragging(value : boolean)
  {
    this.isDragging = value;
  }

  updateTask(task: any) {
    console.error("Not implemented")
  }
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/controllers/calendars/responsible-calendar/responsible-calendar-view.component.ts